export default __webpack_public_path__ + "static/media/mappa_percorsi.45c37d2b.jpg";